export default {"src":"/_next/static/media/code-s-slash-line.2204e7f1.svg","height":24,"width":25,"blurWidth":0,"blurHeight":0};